import { NotificationPresenter } from '@/presentation/presenters/notification/notificationPresenter'

export function useNotificationPresenter(presenter: NotificationPresenter = new NotificationPresenter()) {
  return {
    welcomeNotification: presenter.welcomeNotification.bind(presenter),
    loginNotification: presenter.loginNotification.bind(presenter),
    logoutNotification: presenter.logoutNotification.bind(presenter),
    errorNotification: presenter.errorNotification.bind(presenter),
    registerReviewNotification: presenter.registerReviewNotification.bind(presenter),
    invalidReviewNotification: presenter.invalidReviewNotification.bind(presenter),
    registerReviewErrorNotification: presenter.registerReviewErrorNotification.bind(presenter),
    evaluateNotification: presenter.evaluateNotification.bind(presenter),
    closeEntryNotification: presenter.closeEntryNotification.bind(presenter),
    submitReviewNotification: presenter.submitReviewNotification.bind(presenter),
    copyNotification: presenter.copyNotification.bind(presenter),
    acNotification: presenter.acNotification.bind(presenter),
    wrongNotification: presenter.wrongNotification.bind(presenter),
    freeSpaceResultNotification: presenter.freeSpaceResultNotification.bind(presenter),
    noLoginNotification: presenter.noLoginNotification.bind(presenter),
    recommendEntryNotification: presenter.recommendEntryNotification.bind(presenter)
  }
}
